import React, { useState } from 'react';
import { ResetPasswordView, ResetPasswordViewProps } from './ResetPassword.view';
import { ResetPasswordMutationFn, ResetPasswordMutationVariables } from '../../../models/graphql';
import { RegisterOptions, useForm } from 'react-hook-form';
import { FormOptions, ValidationPatterns } from '../../../constants/form';
import { ValidationMessages } from '../../../constants/validation-messages';
import { SquareButtonIconsEnum } from '../../../constants/square-button-icons';
import { InputTypes } from '../../../constants/form';
import { UseFormProps } from 'react-hook-form/dist/types/form';

export type ResetPasswordControllerProps = Omit<
  ResetPasswordViewProps,
  | 'formInstance'
  | 'onSubmit'
  | 'passwordActionButton'
  | 'passwordRules'
  | 'passwordType'
  | 'setPasswordFieldState'
  | 'tokenRules'
> & {
  token: string;
  resetPasswordMutation: ResetPasswordMutationFn;
};

export const ResetPasswordController = (props: ResetPasswordControllerProps): JSX.Element => {
  // Put All your methods and logic here
  const [passwordActionButton, setPasswordActionButton] = useState<
    SquareButtonIconsEnum.show | SquareButtonIconsEnum.hide
  >(SquareButtonIconsEnum.show);
  const [passwordType, setPasswordType] = useState<InputTypes.password | InputTypes.text>(InputTypes.password);

  const defaultFormValues: ResetPasswordMutationVariables = {
    password: '',
    token: props.token
  };

  const formOptions = { ...FormOptions } as UseFormProps<ResetPasswordMutationVariables>;

  const formInstance = useForm<ResetPasswordMutationVariables>({
    ...formOptions,
    defaultValues: defaultFormValues
  });
  const passwordRules: RegisterOptions = {
    required: ValidationMessages.password.required,
    pattern: {
      value: ValidationPatterns.password,
      message: ValidationMessages.password.invalid
    }
  };
  const tokenRules: RegisterOptions = {
    required: ValidationMessages.token.required
  };

  const setPasswordFieldState: VoidFunction = () => {
    setPasswordType(oldVal => {
      return oldVal === InputTypes.text ? InputTypes.password : InputTypes.text;
    });
    setPasswordActionButton(oldVal => {
      return oldVal === SquareButtonIconsEnum.show ? SquareButtonIconsEnum.hide : SquareButtonIconsEnum.show;
    });
  };

  const onSubmit = async (data: ResetPasswordMutationVariables) => {
    try {
      await props.resetPasswordMutation({ variables: data });
    } catch (error) {
      // we need to have catch since a runtime error will be thrown due to unhandled error from promise
    }
  };

  const viewProps: ResetPasswordViewProps = {
    ...props,
    formInstance,
    onSubmit,
    passwordActionButton,
    passwordRules,
    passwordType,
    setPasswordFieldState,
    tokenRules
  };
  return <ResetPasswordView {...viewProps} />;
};
